import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InputGroup } from "components/bootstrap";
import { useWatchlist } from "watchlist/hooks/useWatchlistsV2";
const WatchlistInfo = styled(InputGroup.Addon)`
  width: auto;
  text-align: left;
  cursor: not-allowed;
`;
const WatchlistParameterPreview = ({ parameter: { watchlistId } }) => {
  const { t } = useTranslation("enterprise_common");
  const { data: watchlist } = useWatchlist(watchlistId);
  const label = watchlist ? `${watchlist.name}` : watchlistId;
  return /* @__PURE__ */ React.createElement(WatchlistInfo, null, t("parameters.watchlist_preview", { label }));
};
export default WatchlistParameterPreview;
